<template>

<div class="question">
  <p><strong>{{ questionData.name }}</strong><br>
  <em>{{ questionData.description }}</em></p>

  <div v-if="viewResponses">
      <p class="is-size-3 has-text-primary">{{ answerDisplay }}</p>
  </div>

  <div v-else>
  <div v-if="questionData.answerType == 2" class="question__response question__response--radio">
    <div class="control">
      <label class="radio"><input type="radio" :name="questionData.name.replace(/ /g, '')" value="1" v-model.number="questionData.answer">1</label>
      <label class="radio"><input type="radio" :name="questionData.name.replace(/ /g, '')" value="2" v-model.number="questionData.answer">2</label>
      <label class="radio"><input type="radio" :name="questionData.name.replace(/ /g, '')" value="3" v-model.number="questionData.answer">3</label>
      <label class="radio"><input type="radio" :name="questionData.name.replace(/ /g, '')" value="4" v-model.number="questionData.answer">4</label>
      <label class="radio"><input type="radio" :name="questionData.name.replace(/ /g, '')" value="5" v-model.number="questionData.answer">5</label>
    </div>
  </div>

  <textarea class="textarea" v-if="questionData.answerType == 1" v-model="questionData.answer"></textarea>

  <div class="control" v-if="questionData.answerType == 3">
    <label class="radio"><input type="radio" :value="true" :name="questionData.name.replace(/ /g, '')" v-model="questionData.answer">{{ i18n.yes }}</label>
    <label class="radio"><input type="radio" :value="false" :name="questionData.name.replace(/ /g, '')" v-model="questionData.answer">{{ i18n.no }}</label>
  </div>  
  </div>

</div>

</template>

<script>
export default {
  name: 'Question',
  props: {
    questionData: Object,
    viewResponses: Boolean,
    lang: String
  },
  computed: {
    answerDisplay() {
      if (typeof this.questionData.answer == "boolean") {
        return this.questionData.answer ? this.i18n.yes : this.i18n.no;
      } else {
        return this.questionData.answer
      }
    },
    i18n() {
      return {
        yes: this.lang === "hi" ? "हाँ" : "Yes",
        no: this.lang === "hi" ? "नहीं" : "No"
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .radio {
    margin-right: 10px;
  }
  .question {
    margin-bottom: 15px;
  }
  .radio input {
    margin-right: 5px;
  }
</style>
